
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class ConvertToWIPBOMGrid extends Serenity.EntityGrid<ConvertToWIPBOMRow, any> {
        protected getColumnsKey() { return 'Inventory.ConvertToWIPBOM'; }
        protected getDialogType() { return ConvertToWIPBOMDialog; }
        protected getIdProperty() { return ConvertToWIPBOMRow.idProperty; }
        protected getInsertPermission() { return ConvertToWIPBOMRow.insertPermission; }
        protected getLocalTextPrefix() { return ConvertToWIPBOMRow.localTextPrefix; }
        protected getService() { return ConvertToWIPBOMService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}